var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoHelp = function SvgIcoHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M0 10c0 5.523 4.477 10 10 10s10-4.477 10-10S15.523 0 10 0 0 4.477 0 10m10.3-3C9.446 7 9 7.574 9 8a1 1 0 0 1-2 0c0-1.784 1.613-3 3.3-3s3.3 1.216 3.3 3c0 .95-.482 1.765-1.17 2.293a3 3 0 0 1-.466.273l-.031.016c-.146.073-.28.141-.415.226-.265.165-.485.361-.624.64a1 1 0 1 1-1.788-.895c.36-.723.906-1.164 1.354-1.443.221-.138.43-.243.575-.316.086-.043.135-.068.16-.082l.026-.012-.001.001c.261-.204.38-.46.38-.701 0-.426-.446-1-1.3-1m-.298 6a.97.97 0 0 0-.707.294.96.96 0 0 0-.295.709q0 .414.295.706a.97.97 0 0 0 .707.291q.412 0 .705-.291a.96.96 0 0 0 .293-.706.97.97 0 0 0-.293-.709.96.96 0 0 0-.705-.294",
    clipRule: "evenodd"
  })));
};
export default SvgIcoHelp;